import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MemberModal from "../components/teams/MemberModal";
import Modal from "../components/teams/Modal";
import TeamCard from "../components/teams/TeamCard";
import Error from "../components/ui/Error";
import { useGetTeamsQuery } from "../features/teams/teamsApi";
import { controlTeamModal } from "../features/teams/teamsSlice";

export default function Teams() {
  //Dispatcher
  const dispatch = useDispatch();
  //Logged in User
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};

  //Some State
  const [team, setTeam] = useState();

  //Modal Condition
  const { teamModal: opened, memberModal: openedMember } = useSelector(
    (state) => state.teams
  );

  //Queris
  const {
    data: teams,
    isLoading,
    isError,
    error,
  } = useGetTeamsQuery(loggedInUser?.email);
  // decide what to render
  let content = null;

  if (isLoading) {
    content = <h6 className="font-bold">Loading...</h6>;
  } else if (!isLoading && isError) {
    content = (
      <h6 className="font-bold">
        <Error message={error?.data} />
      </h6>
    );
  } else if (!isLoading && !isError && teams?.length === 0) {
    content = <h6 className="font-bold">No Team found! Please Add Team</h6>;
  } else if (!isLoading && !isError && teams?.length > 0) {
    content = teams
      .slice()
      .sort((a, b) => a.date - b.date)
      .map((team) => {
        const { id, name, title, date, color } = team;
        //const { name, email: partnerEmail } = getPartnerInfo(

        return (
          <TeamCard
            key={id}
            name={name}
            title={title}
            date={date}
            bg={color}
            setTeam={setTeam}
            team={team}
            teamCard={true}
          />
        );
      });
  }

  return (
    <div>
      <>
        <div className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200">
          <div className="px-10 mt-6 flex justify-between">
            <h1 className="text-2xl font-bold">Teams</h1>
            <button
              onClick={() => dispatch(controlTeamModal())}
              className="flex items-center justify-between px-2 rounded bg-indigo-500 text-white hover:bg-indigo-600 hover:text-indigo-100"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
              <span>Add Team</span>
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-10 mt-4 gap-6 overflow-auto">
            {content}
          </div>
        </div>
        <Modal open={opened} />
        <MemberModal open={openedMember} team={team} />
      </>
    </div>
  );
}
